var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaxTextIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.04,
    height: 18.379,
    viewBox: "0 0 17.04 18.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9574",
    "data-name": "Group 9574",
    transform: "translate(959 22860.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27456",
    "data-name": "Path 27456",
    d: "M13.115,4.32A3.93,3.93,0,0,0,9.19,8.245V14.68a1,1,0,1,0,2,0V11h3.85v3.68a1,1,0,0,0,2,0V8.245A3.93,3.93,0,0,0,13.115,4.32M15.04,9H11.19V8.245a1.925,1.925,0,0,1,3.85,0Z",
    transform: "translate(-959 -22861)",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27457",
    "data-name": "Path 27457",
    d: "M4.973,4.857A1,1,0,1,0,6.387,3.443L4.048,1.1A1.014,1.014,0,0,0,3.722.887,1,1,0,0,0,2.633,1.1L.293,3.443A1,1,0,1,0,1.707,4.857l.633-.633V15.776l-.633-.633A1,1,0,0,0,.293,16.557L2.632,18.9a1,1,0,0,0,1.093.216,1,1,0,0,0,.323-.216l2.339-2.34a1,1,0,0,0-1.414-1.414l-.633.633V4.224Z",
    transform: "translate(-959 -22861)",
    fill: "#991F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxTextIconSelected);
export default __webpack_public_path__ + "static/media/MaxTextIconSelected.d8123f10c110cdd731da0df3fcd952bc.svg";
export { ForwardRef as ReactComponent };